/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/

export default [
  /*{
    url: "/user/profile/view",
    name: "My Profile",
    slug: "coach-profile-view",
    icon: "UserIcon"
    // i18n: "My Profile"
  },*/
  /*{
    url: "/user/messages",
    name: "Messages",
    slug: "coach-messages",
    icon: "MessageSquareIcon"
    // i18n: "My Profile"
  },*/
  /*{
    url: "/user/switch-language",
    name: "Switch Language",
    slug: "coach-switch-languages",
    icon: "StarIcon"
    // i18n: "Switch Language"
  },*/
  /*{
    url: "/user/auth/logout",
    name: "Log Out",
    slug: "user",
    icon: "LogOutIcon"
    // i18n: "Log Out"
  }*/
];
